import React from 'react';
import withBaseComponent from "components/Base"
import Profile from "components/side/Profile"
import ActiveCompany from "components/side/ActiveCompany"

import PerfectScrollbar from "perfect-scrollbar";
import { NavLink } from "react-router-dom";
import cx from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Hidden from "@material-ui/core/Hidden";
import Collapse from "@material-ui/core/Collapse";

import logo from "assets/images/play.png"

// core components
import HeaderLinks from "assets/material-admin/components/Header/HeaderLinks";

import sidebarStyle from "assets/material-admin/assets/jss/material-dashboard-pro-react/components/sidebarStyle.jsx";

import avatar from "assets/material-admin/assets/img/faces/avatar.jpg";

var ps;

class NestedTest extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.siblingOpen && this.props.siblingOpen) {
      this.setState({isOpen: false})
    }

  }
  render() {
    const {classes} = this.props
    const itemText =
            classes.itemText +
            " " +
            cx({
              [classes.itemTextMini]:
              this.props.miniActive && this.state.miniActive,
            });
    const children = this.props.bigGoals || this.props.stepGoals || this.props.actionPlans

    return (
      <List className={classes.list}>
        <ListItem key={this.props.id + " 3"} className={classes.item}>
          <ListItemText
             disableTypography={true}
             onClick={() => {
               this.setState({isOpen: !this.state.isOpen})
               if (this.props.notifyClick) {
                 this.props.notifyClick(this.props.index)
               }

              }}
            primary={this.props.name}
            className={itemText }>

          </ListItemText>
          {children ?
            <Collapse in={this.state.isOpen} >
                {children.map((c) => {
                  return <NestedTest
                              siblingOpen={this.props.siblingOpen || (this.state.activeChildIndex && (this.state.activeChildIndex != c.index))}
                              notifyClick={(i) => {
                                console.log("Child active?", i)
                                this.setState({activeChildIndex: i})
                              }}
                              key={c.id} {...c}
                              classes={classes} />
                  })}
              </Collapse>
              :
            <span/>}
        </ListItem>
      </List>
    )
  }
}

// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
class SidebarWrapper extends React.Component {
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.sidebarWrapper, {
        suppressScrollX: true,
        suppressScrollY: false
      });
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  render() {
    const { classes, className, router, user, headerLinks, links } = this.props;
    // side company will be an element that already has logic for querying for company
    // Either active company
    // Or a companies
    // Both are wrapper functions that will pass to the existing ActiveCompany
    // Profile stays as is
    return (
      <div className={className} ref="sidebarWrapper">
        {/*user*/}
        {/*links*/}
        <Profile
           fileUrl={this.props.routes[0].fileUrl}
           localCommit={this.props.localCommit}
           router={this.props.router}
           __environmentCtx={this.props.routes[0].environment}
           parentClasses={classes}
           profile={this.props.profile} />
        {this.props.companyHeader ?
          this.props.companyHeader
            :
          <span/>}
      </div>
    );
  }
}

class View extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      miniActive: true
    };
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? true : false;
  }
  openCollapse(collapse) {
    var st = {};
    st[collapse] = !this.state[collapse];
    this.setState(st);
  }
  render() {
    const {
      classes,
      color,
      image,
      logoText,
      routes,
      bgColor,
      rtlActive
    } = this.props
    const itemText =
            classes.itemText +
            " " +
            cx({
              [classes.itemTextMini]: this.props.miniActive && this.state.miniActive,
              [classes.itemTextMiniRTL]:
              rtlActive && this.props.miniActive && this.state.miniActive,
              [classes.itemTextRTL]: rtlActive
            });
    const collapseItemText =
            classes.collapsebItemText +
            " " +
            cx({
              [classes.collapseItemTextMini]:
              this.props.miniActive && this.state.miniActive,
              [classes.collapseItemTextMiniRTL]:
              rtlActive && this.props.miniActive && this.state.miniActive,
              [classes.collapseItemTextRTL]: rtlActive
            });
    const userWrapperClass =
            classes.user +
            " " +
            cx({
              [classes.whiteAfter]: bgColor === "white"
            });
    const caret =
            classes.caret +
            " " +
            cx({
              [classes.caretRTL]: rtlActive
            });
    const collapseItemMini =
            classes.collapseItemMini +
            " " +
            cx({
              [classes.collapseItemMiniRTL]: rtlActive
            });
    const photo =
            classes.photo +
            " " +
            cx({
              [classes.photoRTL]: rtlActive
            });
    const drawerPaper =
            classes.drawerPaper +
            " " +
            cx({
              [classes.drawerPaperMini]:
              this.props.miniActive && this.state.miniActive,
              [classes.drawerPaperRTL]: rtlActive
            });
    const sidebarWrapper =
            classes.sidebarWrapper +
            " " +
            cx({
              [classes.drawerPaperMini]:
              this.props.miniActive && this.state.miniActive,
              [classes.sidebarWrapperWithPerfectScrollbar]:
              navigator.platform.indexOf("Win") > -1
            });
    const logoNormal =
            classes.logoNormal +
            " " +
            cx({
              [classes.logoNormalSidebarMini]:
              this.props.miniActive && this.state.miniActive,
              [classes.logoNormalSidebarMiniRTL]:
              rtlActive && this.props.miniActive && this.state.miniActive,
              [classes.logoNormalRTL]: rtlActive
            });
    const logoMini =
            classes.logoMini +
            " " +
            cx({
              [classes.logoMiniRTL]: rtlActive
            });
    const logoClasses =
            classes.logo +
            " " +
            cx({
              [classes.whiteAfter]: bgColor === "white"
            });
    // <div className={logoClasses}>
    //     <a href="https://www.creative-tim.com" className={logoMini}>
    //       <img src={logo} alt="logo" className={classes.img} />
    //     </a>
    //     <a href="https://www.creative-tim.com" className={logoNormal}>
    //       {logoText}
    //     </a>
    //   </div>
    var brand = (
      <div className={logoClasses}>
        <img className="clickable"
           onClick={() => {
             this.props.router.push("/home")
          }}
           width={180}
           height={80}
           src={`/images/play.png`}/>
      </div>
    )
    const sidebar = <SidebarWrapper
    {...this.props}

    className={sidebarWrapper}
      />

    return (
      (
        <div style={{fontWeight: "500 !important"}} ref="mainPanel">
          <Hidden mdUp>
            <Drawer
               anchor="left"
               variant="temporary"
               open={this.props.open}
               classes={{
                 paper: drawerPaper + " " + classes[bgColor + "Background"]
               }}
               onClose={this.props.handleDrawerToggle}
               ModalProps={{
                 keepMounted: true // Better open performance on mobile.
               }}
               >
              {brand}
              {sidebar}
            </Drawer>
          </Hidden>
          <Hidden smDown>
            <Drawer
               anchor="left"
               variant="permanent"
               open
               classes={{
                 paper: drawerPaper + " " + classes[bgColor + "Background"]
               }}
               >
              {brand}
              {sidebar}
            </Drawer>
          </Hidden>
        </div>
      )
    )

  }
}

export default withStyles(sidebarStyle)(View);
